export default "__VITE_ASSET__C96qa4XG__"